<div class="container">
  <!-- <div class="w3-panel w3-card-4"> -->
  <img class="mt-2" src="assets/airimg.png" width="250">
  <div class="row mt-2">
    <div class="col-lg-12 mb-3">
      <div class="row">
        <div class="col-lg-2 mb-3"></div>
        <div class="col-lg-5 mb-3">
          <input class="form-control" type="text" placeholder="AWB NUMBER" [(ngModel)]="track_number"
            (keydown.enter)="sub.focus()">
        </div>
        <div class="col-lg-3 mb-3">
          <button class="btn btn-success" type="button" (click)="submit()" #sub><i
              class="fa fa-search">&nbsp;&nbsp;&nbsp;Track Your Shipment</i></button>
        </div>
      </div>
    </div>
    <hr>



    <!-- <div class="col-lg-1 mb-3"></div>
      <div class="col-lg-10 mb-3" *ngIf="vis_btn == '3'">
       <h3 style="text-align: center;"> Loading.....</h3> 
      </div>
      <div class="col-lg-10 mb-3" *ngIf="vis_btn == '0'">
        <h3 style="text-align: center;">{{t_status}}</h3> 
      </div> -->
      <div class="row" *ngFor="let data of trackData;let i=index;">
    <div class="col-lg-8" >
      <div class="row">
        <!-- <button class="btn_track"  [ngStyle]="{'border-bottom' : vis_btn == '1' ? '3px solid green' : 'none'}" (click)="status_btn()">Shipment Details</button>&nbsp;&nbsp;&nbsp; -->
        <!-- <button class="btn_track"  [ngStyle]="{'border-bottom' : vis_btn == '2' ? '3px solid green' : 'none'}" (click)="status_btn()">Status and Scan</button> -->
        <div class="table-responsive pt-3 col-md-12" style="display:inline-block ;">
          <table class="table table-striped table-bordered table-hover"
            style="font-size:small;border:1.2px solid #94b9b1;">
            <thead>
              <tr style="border:1.2px solid #94b9b1;">
                <th style="background-color:#1abc9c;text-align:right;padding: 6px;width:15%;color: #fff;">Air waybill No
                </th>
                <td style="width:20%;text-align:left;padding: 6px"><b>{{data.details['0'].invoice_no}}</b>
                </td>
              </tr>
              <tr style="border:1.2px solid #94b9b1;">
                <th style="background-color:#1abc9c;text-align:right;padding: 6px;width:15%;color: #fff">Reference No
                </th>
                <td style="width:20%;text-align:left;padding: 6px">{{data.details['0'].ref_no}}</td>
              </tr>
              <tr style="border:1.2px solid #94b9b1;">
                <th style="background-color:#1abc9c;text-align:right;padding: 6px;width:15%;color: #fff">Origin</th>
                <td style="width:20%;text-align:left;padding: 6px">{{data.details['0'].Origin}}</td>
              </tr>
              <tr style="border:1.2px solid #94b9b1;">
                <th style="background-color:#1abc9c;text-align:right;padding: 6px;width:15%;color: #fff">Pickup Date
                </th>
                <td style="width:20%;text-align:left;padding: 6px">{{data.details['0'].invoicedate}}</td>
              </tr>
              <tr style="border:1.2px solid #94b9b1;">
                <th style="background-color:#1abc9c;text-align:right;padding: 6px;width:15%;color: #fff">Destination
                </th>
                <td style="width:20%;text-align:left;padding: 6px">{{data.details['0'].wh_storage_location_name}}</td>
              </tr>
              <tr style="border:1.2px solid #94b9b1;">
                <th style="background-color:#1abc9c;text-align:right;padding: 6px;width:15%;color: #fff">Shipment Status
                </th>
                <td style="width:20%;text-align:left;padding: 6px">{{data.details['0'].current_status}}</td>
              </tr>
              <tr style="border:1.2px solid #94b9b1;">
                <th style="background-color:#1abc9c;text-align:right;padding: 6px;width:15%;color: #fff">Delivery Date
                </th>
                <td style="width:20%;text-align:left;padding: 6px">{{data.details['0'].deliverydate}}</td>
              </tr>
              <tr style="border:1.2px solid #94b9b1;">
                <th style="background-color:#1abc9c;text-align:right;padding: 6px;width:15%;color: #fff">Receiver Name
                </th>
                <td style="width:20%;text-align:left;padding: 6px">{{data.details['0'].receivedby}}</td>
              </tr>
            </thead>
          </table>
        </div>


        <div class="table-responsive pt-3 col-md-12">
          <table class="table table-striped table-bordered table-hover"
            style="font-size: small;border:1.2px solid #94b9b1;">
            <thead>
              <tr>
                <th style="background-color:#1abc9c;padding: 6px;width:18%;color: #fff">Date</th>
                <th style="background-color:#1abc9c;padding: 6px;width:13%;color: #fff">Facility</th>
                <th style="background-color:#1abc9c;padding: 6px;width:25%;color: #fff">Description</th>
              </tr>
              <tr *ngFor="let track of trackData[i]['summary'];let j=index" style="border:1.2px solid #94b9b1;">
                <td style="padding: 6px;">{{track.transit_date}}</td>
                <td style="padding: 6px;">{{track.dest_point}}</td>
                <td style="padding: 6px;">{{track.curr_status}}</td>
              </tr>
            </thead>
          </table>
        </div>
      </div>
      <hr>
    </div>
    <div class="col-md-4" *ngIf="dlyMsg == 'Delivered' || dlyMsg == 'DELIVERED' && trackData">
      <button class="btn btn-sm btn-green btn-block align-center"
        (click)="view_pod(data)" >
        View POD
      </button>
      <img *ngIf="fpodImg" [src]="data.details[0].pod" width="350" height="400">
      <button class="btn btn-sm btn-green btn-block align-center"
        (click)="download_pod(data.details[0].podImg,data.details['0'].invoice_no)"  *ngIf="visibleDownload == '1'">Download POD
        <!-- <a href="fpodImg.jpg" download>Download POD</a> -->
        
      </button>
    </div>
    </div>
  </div>
  <!-- </div> -->
</div>
<h3 style="color:brown;text-align: center;" *ngIf="errMsg">
  {{errMsg}}</h3>